import React, { useMemo } from 'react';
import { AbsenceResponseDto } from '@docbay/schemas';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { ReactComponent as WarningIcon } from 'applicaiton/assets/warning.svg';
import { PathNames } from 'applicaiton/routes';
import { userHasPermission } from 'common/helpers/userHasPermission';
import { UserPermissions } from 'applicaiton/constants/userPermissions';

import {
  Wrapper,
  DateWrapper,
  Date,
  Name,
  IconsWrapper,
  StyledCalendarIcon,
  StyledDeleteIcon,
} from './styles';

require('dayjs/locale/pt');
require('dayjs/locale/fr');

interface Props {
  data: AbsenceResponseDto;
  onDelete: (value: AbsenceResponseDto | null) => void;
}

const AbsenceItem = ({ data, onDelete }: Props) => {
  const { t, i18n } = useTranslation();
  dayjs.locale(i18n.language);
  const location = useLocation();
  const isMyAgendaPage = location.pathname === PathNames.clinicOwnerSchedule;
  const isCanCancelAgenda = userHasPermission(
    UserPermissions.cancelAgenda,
    Number(data.clinic?.owner?.id),
    isMyAgendaPage,
  );
  const isSame = useMemo(() => {
    const diff = dayjs(dayjs(data?.startDate).format('YYYY-MM-DD')).diff(
      dayjs(dayjs(data?.endDate).format('YYYY-MM-DD')),
    );

    return diff === 0;
  }, [data]);

  const endDateFormatted = isSame
    ? dayjs(data?.endDate || null)
        .tz()
        .format('HH:mm')
    : dayjs(data?.endDate || null)
        .tz()
        .format('DD MMMM HH:mm');

  return (
    <Wrapper>
      <WarningIcon />
      <div>
        <DateWrapper>
          <Date>
            <span>{dayjs(data?.startDate).tz().format('DD MMMM')}</span>{' '}
            {t('from')}{' '}
            <span>{dayjs(data?.startDate).tz().format('HH:mm')}</span> {t('to')}{' '}
            <span>{endDateFormatted}</span>
          </Date>
          <IconsWrapper>
            <StyledCalendarIcon onClick={() => {}} />
            {isCanCancelAgenda && (
              <StyledDeleteIcon onClick={() => onDelete(data)} />
            )}
          </IconsWrapper>
        </DateWrapper>
        <Name>Absence Hours</Name>
      </div>
    </Wrapper>
  );
};

export default AbsenceItem;
